module.exports = __webpack_public_path__ + "static/img/answerbg.074b252.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/answerbg.png
// module id = NhZh
// module chunks = 1